import * as Api from '@ViewModels';
import escapeRegExp from 'lodash.escaperegexp';

export class TagListAutoCompleteViewModel extends Api.ResourceAutoCompleteViewModel<string> {
	private mAllTags: string[];
	constructor(
		userSession: Api.UserSessionContext,
		tags: string[],
		options?: Partial<Api.IResourceAutoCompleteOptions>
	) {
		super(userSession, {
			...(options || {}),
			type: Api.ResourceAutoCompleteViewModelType.Tag,
		});
		this.mGetOpResult = this.mGetOpResult.bind(this);
		this.mAllTags = tags || [];
	}

	protected mGetOpResult(computedParams?: Api.IDictionary<any>) {
		return new Promise(resolve => {
			const query = computedParams?.[this.mOptions.searchParamName] || '';
			const filter = query ? new RegExp(`^${escapeRegExp(query)}`, 'igm') : null;
			const values = filter
				? (this.mAllTags || []).filter(x => {
						filter.lastIndex = 0;
						return filter.test(x);
					})
				: this.mAllTags || [];
			const opResult: Api.IOperationResult<Api.IPagedCollection<string>> = {
				success: true,
				systemCode: 200,
				value: {
					values,
				},
			};
			resolve(opResult);
		});
	}
}
